import React, { Component } from 'react';
import ComboBox from '../combo-box'
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import SearchIcon from 'material-ui-icons/Search'
import Portal from 'material-ui/Portal'
import EmployeeForm from './EmployeeForm';
import Input from 'material-ui/Input';
import SaveIcon from 'material-ui-icons/Save';
import CloseIcon from 'material-ui-icons/Close';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import Dialog, { DialogTitle } from 'material-ui/Dialog';

import Tooltip from 'material-ui/Tooltip';
import AddIcon from 'material-ui-icons/Add';
import DownloadIcon from 'material-ui-icons/FileDownload';
import UploadIcon from 'material-ui-icons/FileUpload';
import RemoveFPIcon from 'material-ui-icons/PortableWifiOff';
import DeleteIcon from 'material-ui-icons/DeleteForever';
import EditIcon from 'material-ui-icons/ModeEdit';
import ImportIcon from 'material-ui-icons/ImportContacts';

import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List';

import { ajaxPost } from '../ajax';
import IconButton from 'material-ui/IconButton/IconButton';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';

import DeleteEmployeeDialog from './DeleteEmployeeDialog';
import SelectDeviceDialog from './SelectDeviceDialog';
import FingerprintIcon from 'material-ui-icons/Fingerprint';
import EnrollDialog from './EnrollDialog';
import MessageBoxYesNo from './MessageBoxYesNo';
import EnrollStatus from './EnrollStatus';

const fileDialog = require('file-dialog');

var { fnSearchEmployee } = require('./utils');


const styles = theme => ({
    page: {

    },
    search: {
        width: 200,
        //color: "white",
        height: 50,
    },
    input:
        {
            position: "absolute",
            marginTop: 15,
        },
    title:
        {
            // float: "left",
            // flex: 1,
            // marginTop: 10,
        },
    button: {
        '&:hover': {
            backgroundColor: green[700],

        },
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -25,
        marginLeft: -25,
    },
    wrapper: {
        //margin: "",//theme.spacing.unit,
        position: 'relative',
    },

    dialog:
        {
            margin: "20px 20px 40px 20px"
        },
    main:
        {
            margin: 10,
            height: "35px",
        },
    toolBarImage: {
        width: "20px",
        height: "20px",
    },
    tableContent:{
        "font-weight":"500",
    },
    TableCell: {
        padding:"5px",
        paddingRight: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
    },
    tableHeader: {
        position: "fixed",
    }
});



class SearchEmployee extends Component {

    state =
        {
            selected: null,
            search: '',
            listEmployees: [],
            deleteDialog: false,
            downloadDialog: false,
            uploadDialog: false,
            removeDialog: false,
            enrollDialog: false,
            enrollStatus: false,
            page: 0,
            totalEmployees: 0,
            loading: false,
            DeviceCommandID: -1,
        };

    constructor(props) {
        super(props);
        this.state = props.searchState;
    }

    componentDidMount() {
        //  this.setState({listEmployees:this.props.searchState.listEmployees});
    }

    empForm = null;

    onSearch = (event) => {
        var str = event.target.value;
        this.setState({ search: str })
        setTimeout(this.doSearch, 200, str, event.target);

    }

    onClickSearch = (event) => {
        this.doSearch(this.state.search);
    }

    doSearch = (str, source) => {

        if (source != null && str != source.value) {
            setTimeout(this.doSearch, 200, source.value, source);
            return;
        }
        this.setState({ loading: true });
        fnSearchEmployee(str, dataCount => {
            if (!(source != null && str != source.value)) {
                this.setState({ totalEmployees: dataCount });
                this.handleChangePage(null, 0);
            }
        },
            true
        );

    }

    onSelectEmployee(emp, event) {
        if (this.props.onSelectEmployee != null)
            this.props.onSelectEmployee(emp, this.state);

        this.setState({ selected: emp })
    }


    onDownload = () => {
        this.setState({ downloadDialog: true });
    }

    onUpload = () => {
        this.setState({ uploadDialog: true });
    }

    onRemove = () => {
        this.setState({ removeDialog: true });
    }

    onDelete = () => {
        this.setState({ deleteDialog: true });
    }

    onDeleteDialogClose = (success) => {
        this.setState({ deleteDialog: false });
        if (success) {
            this.setState({ listEmployees: this.state.listEmployees.filter(item => item != this.state.selected) })
            this.setState({ selected: null });
            this.setState({ totalEmployees: this.state.totalEmployees - 1 });
        }

    }

    onDownloadDialogClose = (success) => {
        this.setState({ downloadDialog: false });
    }

    onUploadDialogClose = (success) => {
        this.setState({ uploadDialog: false });
    }

    onRemoveDialogClose = (success) => {
        this.setState({ removeDialog: false });
    }


    onActionDownload = (dev) => {
        ajaxPost({
            url: '/DeviceCommandAPI/SendDownloadUserDeviceCommand',
            data: {
                DeviceID: dev.DeviceID,
                EmployeeIDs: [this.state.selected.EmployeeID],
            },
            onSuccess: data => {
                global.updateNotifications();
                this.setState({ downloadDialog: false });
            },
            finally: () => { }
        });
    }

    onActionUpload = (dev) => {
        ajaxPost({
            url: '/DeviceCommandAPI/SendUploadUserDeviceCommand',
            data: {
                DeviceIDs: dev == null ? [] : [dev.DeviceID],
                EmployeeIDs: [this.state.selected.EmployeeID],
                Privilege: this.state.selected.RoleType,
            },
            onSuccess: data => {
                global.updateNotifications();
                this.setState({ uploadDialog: false });
            },
            finally: () => { }
        });
    }

    onActionRemove = (result) => {
        var state = this.state;
        if (result == false) {
            this.setState({ removeDialog: false });
            return;
        }
        ajaxPost({
            url: '/DeviceCommandAPI/SendDeleteUserDeviceCommand',
            data: {
                DeviceIDs: [],
                EmployeeIDs: [this.state.selected.EmployeeID],
                Privilege: this.state.selected.RoleType,
            },
            onSuccess: data => {
                global.updateNotifications();
                this.setState({ removeDialog: false });

                this.state.selected.FPCount = 0;
                this.forceUpdate();

            },
            finally: () => { }
        });
    }

    onEnroll = () => {
        this.setState({ enrollDialog: true });
    }

    onEnrollDialogClose = () => {
        this.setState({ enrollDialog: false });
    }

    onActionEnroll = (id) => {
        this.state.DeviceCommandID = id;
        this.setState({ enrollDialog: false });
        this.setState({ enrollStatus: true });
    }

    onActionEnrollStatus = () => {
        this.setState({ enrollStatus: false });
    }

    onImport = () => {
        fileDialog({ accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }).then(file => {
            const data = new FormData();
            data.append('file', file[0]);
            data.append('RequestClass', JSON.stringify(
                {
                    SessionID: global.sessionID,
                }
            ));

            // Post to server
            fetch(window.apihost + '/EmployeeAPI/ImportEmployees', {
                method: 'POST',
                body: data
            }).then((resp) => {
                return resp.json();
            }).then((json) => {
                global.updateNotifications();
            });

        });
    }

    handleChangePage = (event, page) => {
        this.setState({ page });

        const rowsPerPage = 50;

        this.setState({ loading: true });

        fnSearchEmployee(this.state.search, data => {
            this.setState({ loading: false });
            this.setState({ listEmployees: data });

        }, false, page * rowsPerPage, rowsPerPage);
    }

    render() {
        var { classes } = this.props;
        var classesInput =
            {
                input: classes.input,
            }

        return (
            <div className={classes.main}>
                <Portal container={this.props.toolbar}>
                    <Portal container={global.lblHeader}>
                        <Typography variant="title" color="inherit" className={classes.title}>
                            <span>
                                Employee Module
                            </span>
                        </Typography>
                    </Portal>

                    <Input onChange={this.onSearch} className={classes.search} value={this.state.search} classes={classesInput} />
                    <div className={classes.wrapper}>
                        <IconButton color="inherit" className={classes.button} onClick={this.onClickSearch.bind(this)}>
                            {/* <SearchIcon /> */}
                            <img src="search.png" className={classes.toolBarImage} />
                            {this.state.loading && <CircularProgress size={50} className={classes.fabProgress} />}
                        </IconButton>
                    </div>
                    <div className={classes.wrapper}>
                        <Tooltip id="tooltip-import" title="Import from Excel">
                            <IconButton color="contrast" className={classes.button}
                                onClick={this.onImport.bind(this)} style={{ "color": "#606060" }}
                            >
                                <ImportIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-add" title="Add">
                            <IconButton color="contrast" className={classes.button} onClick={this.props.onAdd.bind(this, this.state)}>
                                <img src="add.png" className={classes.toolBarImage} />
                                {/* <AddIcon /> */}
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-edit" title="Edit">
                            <IconButton disabled={this.state.selected == null} color="inherit" className={classes.button}  onClick={this.props.onEdit.bind(this, this.state)}>
                            { this.state.selected==null ? <img src="edit-disable.png" className={classes.toolBarImage}/> :  <img src="edit.png" className={classes.toolBarImage}/> }
             
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-delete" title="Delete">
                            <IconButton disabled={this.state.selected == null} color="inherit" className={classes.button} onClick={this.onDelete.bind(this)}>
                            { this.state.selected==null ? <img src="delete-disable.png" className={classes.toolBarImage}/> :  <img src="delete.png" className={classes.toolBarImage}/> }
             
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-enroll" title="Enroll Employee Fingerprint to Device">
                            <IconButton disabled={this.state.selected == null} color="contrast" className={classes.button} onClick={this.onEnroll.bind(this)}>
                                <FingerprintIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-download" title="Download Employee Record from Device">
                            <IconButton disabled={this.state.selected == null} color="inherit" className={classes.button} onClick={this.onDownload.bind(this)}>
                            { this.state.selected==null ? <img src="download-disable.png" className={classes.toolBarImage}/> :  <img src="download.png" className={classes.toolBarImage}/> }
             
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-upload" title="Upload Employee Record to Device">
                            <IconButton disabled={this.state.selected == null} color="inherit" className={classes.button} onClick={this.onUpload.bind(this)}>
                            { this.state.selected==null ? <img src="upload-disable.png" className={classes.toolBarImage}/> :  <img src="upload.png" className={classes.toolBarImage}/> }
             
                            </IconButton>
                        </Tooltip>
                        <Tooltip id="tooltip-delete-fp" title="Remove Employee Fingerprint Record">
                            <IconButton disabled={this.state.selected == null} color="contrast" className={classes.button} onClick={this.onRemove.bind(this)}>
                                <RemoveFPIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </Portal>
                <Paper style={{ "background":"rgba(255,255,255,0.5)"}}>
                    <Table>
                        <Portal container={global.tblHeader}>
                         <TableHead>
                                <TableRow>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"80px","maxWidth": "80px"}}>AIMS ID</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"230px","maxWidth": "230px"}}>Name</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"80px","maxWidth": "80px"}} >Company</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"150px","maxWidth": "150px"}}>Department</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"100px","maxWidth": "100px"}}>Position</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"120px","maxWidth": "120px"}}>USER TYPE</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"100px","maxWidth": "100px"}}>FP COUNT</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"80px","maxWidth": "80px"}}>RFID</TableCell>
                                    <TableCell className={classes.TableCell} style={{ "minWidth":"50px","maxWidth": "50px"}}>PIN</TableCell>
                                    <TableCell >&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                          </Portal>
                         <TableBody className={classes.tableContent}>
                            {this.state.listEmployees.map(n => {
                                return (
                                    <TableRow selected={n === this.state.selected} onClick={this.onSelectEmployee.bind(this, n)}>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"75px","maxWidth": "75px","padding":"0"}}>{n.EmployeeNo}</TableCell>
                                        <TableCell className={classes.TableCell} tyle={{ "minWidth":"150","maxWidth": "150px"}}>{n.FullName}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"80px","maxWidth": "80px"}}>{n.Company}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"150px","maxWidth": "150px"}}>{n.Department}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"100px","maxWidth": "100px"}}>{n.Position}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"120px","maxWidth": "120px"}}>{n.RoleType}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"100px","maxWidth": "100px"}}>{n.FPCount.toString()}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"80px","maxWidth": "80px"}}>{n.RFID == null || n.RFID == "" ? "NA" : "YES"}</TableCell>
                                        <TableCell className={classes.TableCell} style={{ "minWidth":"80px","maxWidth": "80px"}}>{n.PIN == null || n.PIN == "" ? "NA" : "YES"}</TableCell>
                                        <TableCell>&nbsp;</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    colSpan={6}
                                    count={this.state.totalEmployees}
                                    rowsPerPage={50}
                                    rowsPerPageOptions={[50]}
                                    page={this.state.page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                {this.state.deleteDialog && <DeleteEmployeeDialog open={true} employee={this.state.selected} onClose={this.onDeleteDialogClose.bind(this)} />}
                {this.state.downloadDialog &&
                    <SelectDeviceDialog title="Download Employee Record from Device"
                        action="download"
                        employee={this.state.selected}
                        onClose={this.onDownloadDialogClose.bind(this)}
                        onAction={this.onActionDownload}
                        caption="Select the device you want the fingerprint to be downloaded from"
                        allowSelectAll={false}
                    />}
                {this.state.uploadDialog &&
                    <SelectDeviceDialog title="Upload Employee Record to Device"
                        action="upload"
                        employee={this.state.selected}
                        onClose={this.onUploadDialogClose.bind(this)}
                        onAction={this.onActionUpload}
                        allowSelectAll={true}
                        caption="Select the device you want the fingerprint to be uploaded to"
                    />}
                {this.state.removeDialog &&
                    <MessageBoxYesNo title="Remove Employee Fingerprint Record"
                        onAction={this.onActionRemove}
                        message="Are you sure you want to remove the employee's fingerprint record"
                    />}

                {this.state.enrollDialog &&
                    <EnrollDialog title="Enroll Employee Fingerprint to Device"
                        action="enroll"
                        employee={this.state.selected}
                        onClose={this.onEnrollDialogClose.bind(this)}
                        onAction={this.onActionEnroll}
                    />}
                {this.state.enrollStatus &&
                    <EnrollStatus
                        DeviceCommandID={this.state.DeviceCommandID}
                        _parent2={this}
                        onAction={this.onActionEnrollStatus.bind(this)}
                    />
                }

            </div>
        )

    }
}

export default withStyles(styles)(SearchEmployee);



// WEBPACK FOOTER //
// ./src/admin/SearchEmployee.js